import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
const Login = lazy(() => import("@/pages/Login"));
const RegisterDistributor = lazy(() => import("@/pages/RegisterDistributor"));
const Checkout = lazy(() => import("@/pages/Checkout"));
const Purchase = lazy(() => import("@/pages/Purchase"));
const StampPurchase = lazy(() => import("@/pages/StampPurchase"));
const PaymentResult = lazy(() => import("@/pages/PaymentResult"));
const CustomerDashboard = lazy(() => import("@/pages/CustomerDashboard"));
const DistributorDashboard = lazy(() => import("@/pages/DistributorDashboard"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const TvDisplay = lazy(() => import("@/pages/TvDisplay"));
const Renew = lazy(() => import("@/pages/Renew"));

function PageLoader() {
  return <div className="flex min-h-screen items-center justify-center"><span className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" /></div>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tv" element={<TvDisplay />} />
            <Route path="/renovar/:token" element={<Renew />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro-distribuidor" element={<RegisterDistributor />} />
            <Route path="/comprar" element={<Purchase />} />
            <Route path="/timbres/comprar" element={<StampPurchase />} />
            <Route path="/payment/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentResult state="success" />} />
            <Route path="/payment/pending" element={<PaymentResult state="pending" />} />
            <Route path="/payment/failure" element={<PaymentResult state="failure" />} />
            <Route
              path="/panel/cliente"
              element={
                <ProtectedRoute role="customer">
                  <CustomerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/panel/distribuidor"
              element={
                <ProtectedRoute role="distributor">
                  <DistributorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/panel/admin"
              element={
                <ProtectedRoute role="superadmin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
